<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <component :is="compName" :compProps="prizeInfo" :payLoad="uiPayLoad" :compId="(compProps.elementId+'')" @action="actionHandle"></component>
    <component :is="servCompName" :payLoad="payLoad" :compIndex="compIndex" @update="updateHandle" @init="initHandle" :compProps="compProps" @finish="finishHandle"></component>
  </section>
</template>
<script>
import PrizeDraw from '@/components/PrizeDraw'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'

export default {
  mixins: [mixin],
  data() {
    return {
      // 这里存的是大转盘抽奖信息，个人奖品以及中奖轮播信息
      prizeInfo: {
        myPrize: [],
        allPrize: {},
        otherPrize: {}
      },
      // 这里是抽奖，保存地址等调用接口信息，由于频繁调用所以单独拎出来处理
      uiPayLoad: {},
      payLoad: null
    }
  },
  components: {
    PrizeDraw,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    compName() {
      return 'PrizeDraw'
    }
  },
  methods: {
    /**
     * 初始化接口，用于获得业务组件的初始化数据
     */
    initHandle(payLoad) {
      this.prizeInfo = payLoad
    },
    /**
     * 用于更新业务组件获得的接口数据 虽然功能和init一样 但是还是区分下
     */
    updateHandle(payLoad) {
      this.prizeInfo = payLoad
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payLoad) {
      this.payLoad = payLoad
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle(payLoad) {
      switch (payLoad.type) {
      case 'drawFinish':
        this.uiPayLoad = payLoad
        break
      case 'cantDraw':
        this.uiPayLoad = payLoad
        break
      case 'refreshFinish':
        this.prizeInfo = payLoad.data
        break
      case 'saveFinish':
        this.uiPayLoad = payLoad
        break
      default:
      }
    }
  }
}
</script>
